import React from "react";
import { NewChatAdmin, NewChatWrap } from "./components";
import { usePostAdminNewChat } from "./hooks";

const ChatCreateFormAdmin = () => (
  <NewChatWrap Content={NewChatAdmin} useHook={usePostAdminNewChat} />
);

export default ChatCreateFormAdmin;
